/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function GasPump(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M240.9707,69.65625l-19.314-19.31348a8.00018,8.00018,0,1,0-11.31348,11.31446l19.313,19.3125A7.94757,7.94757,0,0,1,232,86.62695V168a8,8,0,0,1-16,0V128a24.0275,24.0275,0,0,0-24-24H176V56a24.0275,24.0275,0,0,0-24-24H72A24.0275,24.0275,0,0,0,48,56V208H32a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16H176V120h16a8.00917,8.00917,0,0,1,8,8v40a24,24,0,0,0,48,0V86.62695A23.84506,23.84506,0,0,0,240.9707,69.65625ZM144,120H80a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z" />
    </Svg>
  );
}

export default GasPump;
